$(document).ready(function () {
    (function () {
        let ajaxLockActive = false;
        const ajaxPathProductLabel = '/action/product-label';
        const ajaxPathProductLabelActivate = '/activate';
        const ajaxPathProductLabelDeactivate = '/deactivate';

        let scale = 1;

        const draggableElementWidth = 150;
        const draggableElementHeight = 34;

        const textPositionClasses = [
            'top_left',
            'top_center',
            'top_right',
            'middle_left',
            'center',
            'middle_right',
            'bottom_left',
            'bottom_center',
            'bottom_right'
        ];

        initColorPickers();
        initTooltip();

        $(document).on('click', '#product_label_form_wrapper .product_label_element', function () {
            if (!$('#product_label_form_wrapper #product_label_canvas', document).length) {
                return;
            }

            const element = $(this);
            const onCanvas = element.attr('data-on-canvas');
            const elementName = element.attr('data-name');
            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);

            if (onCanvas == '0') {
                element.attr('data-on-canvas', '1');
                element.attr('title', 'Remove from canvas');
                element.addClass('btn-danger').removeClass('btn-primary');

                // toggle element settings
                $('.product_label_element_settings', document).hide();
                $(`.product_label_element_settings[data-name=${elementName}]`, document).show();

                // disable all draggable elements
                canvas.find('.draggable').removeClass('active');

                // show or append new draggable active element on canvas
                const draggableElement = canvas.find(`.draggable[data-name='${elementName}']`, document);
                if (draggableElement.length > 0) {
                    draggableElement.show().addClass('active');
                } else {
                    const newDraggableElement = $(`<div class='draggable active' data-name='${elementName}'>
                                                    <div class='draggable-width'>${Number(draggableElementWidth * scale).toFixed(1)} mm</div>
                                                    <div class='draggable-height'>${Number(draggableElementHeight * scale).toFixed(1)} mm</div>
                                                    <div class="draggable-name">${element.text().trim()}</div>
                                                    </div>`);
                    canvas.append(newDraggableElement);
                    initDraggable(newDraggableElement[0]);
                }
            }

            if (onCanvas == '1') {
                element.attr('data-on-canvas', '0');
                element.attr('title', 'Add to canvas');
                element.removeClass('btn-danger').addClass('btn-primary');
                const draggableElement = canvas.find(`.draggable[data-name='${elementName}']`);
                draggableElement.hide().removeClass('active');

                // activate sibling visible draggable element if canvas doesn't have active draggable element
                if (!canvas.find(`.draggable.active`).length) {
                    const draggableElementSibling = draggableElement.siblings('.draggable:visible').first();
                    if (draggableElementSibling.length) {
                        $('.product_label_element_settings', document).hide();
                        draggableElementSibling.addClass('active');
                        const draggableElementSiblingName = draggableElementSibling.attr('data-name');
                        $(`.product_label_element_settings[data-name=${draggableElementSiblingName}]`, document).show();
                    }
                }
            }

            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_generate_canvas_btn', function () {
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();

            if (!width || !height || isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                alert('Please enter correct width and height');
                return;
            }

            const canvasWrapper = $('#product_label_form_wrapper #product_label_canvas_wrapper', document);
            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();

            const aspectRatio = width / height;
            const canvasWidth = canvasWrapper[0].getBoundingClientRect().width;
            const canvasHeight = canvasWidth / aspectRatio;

            scale = width / canvasWidth;

            let canvas;
            if (productLabelId > 0) {
                canvas = $('#product_label_form_wrapper #product_label_canvas', document);
            } else {
                $('#product_label_elements_list .product_label_element', document)
                    .attr('data-on-canvas', '0')
                    .attr('title', 'Add to canvas')
                    .removeClass('disabled')
                    .removeClass('btn-danger')
                    .addClass('btn-primary');
                canvas = $(`<div id='product_label_canvas'></div>`);
                canvasWrapper.html(canvas);
            }

            canvas.css({
                'width': `100%`,
                'height': `${Number(canvasHeight).toFixed(2)}px`
            });

            // set real size of draggable elements
            if (canvas.find('.draggable').length) {
                canvas.find('.draggable').each(function (_, draggableElement) {
                    const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                    const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                    $(draggableElement).find('.draggable-width').text(`${Number(elementWidth * scale).toFixed(1)} mm`);
                    $(draggableElement).find('.draggable-height').text(`${Number(elementHeight * scale).toFixed(1)} mm`);
                });
            }

            $('#product_label_form_wrapper #product_label_buttons', document).show();

            return false;
        });

        $(document).on('click', '#product_label_list .list-group-item', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $(this).attr('data-product-label-id');

            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showPreloader();

            getProductLabelForm(productLabelId);
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_save_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            if (!validateForm()) {
                return false;
            }

            const draggableElements = $('#product_label_canvas .draggable:visible', document);

            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);
            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            const name = $('#product_label_form_wrapper #product_label_name', document).val();
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();
            const canvasWidth = canvas[0].getBoundingClientRect().width;
            const canvasHeight = canvas[0].getBoundingClientRect().height;

            const data = {
                name: name
            };
            const params = {
                width: Number(width),
                height: Number(height),
                scale:  width  / Number(canvasWidth),
                elements: {}
            };
            draggableElements.each(function (_, draggableElement) {
                const elementName = $(draggableElement).attr('data-name');
                const elementX = $(draggableElement).attr('data-x') ? parseFloat($(draggableElement).attr('data-x')) : 0;
                const elementY = $(draggableElement).attr('data-y') ? parseFloat($(draggableElement).attr('data-y')) : 0;
                const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                params.elements[elementName] = {
                    x: Number(elementX),
                    y: Number(elementY),
                    width: Number(elementWidth),
                    height: Number(elementHeight)
                }

                // Set font size
                if ($(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document).length) {
                    params.elements[elementName].font_size = Number($(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document).val());
                }

                // Set font color
                if ($(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document).length) {
                    params.elements[elementName].font_color = $(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document).css('background-color');
                }

                // Set text position
                if ($(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document).length) {
                    params.elements[elementName].text_position = $(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document).val();
                }

                // Set barcode image position
                if ($(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document).length) {
                    params.elements[elementName].image_position = $(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document).val();
                }
            });

            data.params = JSON.stringify(params);

            ajaxLockActive = true;
            showPreloader();

            if (productLabelId == 0) {
                createProductLabel(data);
            }

            if (productLabelId > 0) {
                updateProductLabel(productLabelId, data);
            }

            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_canvas .draggable', function () {
            const draggableElement = $(this);
            draggableElement.addClass('active').siblings().removeClass('active');
            const name = draggableElement.attr('data-name');

            $(`.product_label_element_settings`, document).hide();
            $(`.product_label_element_settings[data-name='${name}']`, document).show();

            return false;
        });

        $(document).on('change', '#product_label_form_wrapper .product_label_element_text_position', function () {
            const elementName = $(this).parents('.product_label_element_settings').attr('data-name');
            const value = $(this).val();

            $(`#product_label_canvas .draggable[data-name=${elementName}]`, document).removeClass(textPositionClasses.join(' ')).addClass(`${value}`);

            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_activate_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showPreloader();

            activateProductLabel(productLabelId);
            return false;
        });

        $(document).on('click', '#product_label_form_wrapper #product_label_deactivate_btn', function () {
            if (ajaxLockActive) {
                return false;
            }

            const productLabelId = $('#product_label_form_wrapper #product_label_id', document).val();
            if (productLabelId <= 0) {
                return false;
            }

            ajaxLockActive = true;
            showPreloader();

            deactivateProductLabel(productLabelId);
            return false;
        });

        $(document).on('change', '#product_label_list_wrapper input[name="display_deactivated"]', function(e){
            if (ajaxLockActive) {
                return false;
            }

            ajaxLockActive = true;
            showPreloader();

            refreshList();

            return false;
        });

        $(document).on('click', '#product_label_list_wrapper span#filter_span_wrapper', function () {
            $('div#filter_options_wrapper', document).toggle();

            const arrow = $('span#filter_span_wrapper span.glyphicon');
            if (arrow.hasClass('glyphicon-chevron-right')) {
                arrow.removeClass('glyphicon-chevron-right');
                arrow.addClass('glyphicon-chevron-down');
            } else {
                arrow.removeClass('glyphicon-chevron-down');
                arrow.addClass('glyphicon-chevron-right');
            }

            return false;
        });

        function validateForm() {
            let errorMessage = '';

            const name = $('#product_label_form_wrapper #product_label_name', document).val();
            const width = $('#product_label_form_wrapper #product_label_width', document).val();
            const height = $('#product_label_form_wrapper #product_label_height', document).val();

            if (name === '') {
                errorMessage += `<li>Produktetikettnavn er feil</li>`;
            }

            if (width === '' || isNaN(width) || width <= 0) {
                errorMessage += '<li>Bredde er feil</li>';
            }

            if (height === '' || isNaN(height) || height <= 0) {
                errorMessage += '<li>Høyde er feil</li>';
            }

            const draggableElements = $('#product_label_canvas .draggable:visible', document);

            if (!draggableElements.length) {
                errorMessage += '<li>Legg til minst ett produktetikettelement på lerretet</li>';
            }

            if (!checkOverlaps(draggableElements)) {
                errorMessage += '<li>Det er overlappende produktetikett elementer på lerretet. Vennligst juster plasseringen og størrelsen på elementene</li>';
            }

            draggableElements.each(function (_, draggableElement) {
                const elementName = $(draggableElement).attr('data-name');
                const fontSizeInput = $(`#product_label_element_settings_list input[name='${elementName}_font_size']`, document);
                const fontColorBtn = $(`#product_label_element_settings_list button[name='${elementName}_font_color']`, document);
                const textPositionSelect = $(`#product_label_element_settings_list select[name='${elementName}_text_position']`, document);
                const imagePositionSelect = $(`#product_label_element_settings_list select[name='${elementName}_image_position']`, document);

                const elementWidth = $(draggableElement)[0].getBoundingClientRect().width;
                const elementHeight = $(draggableElement)[0].getBoundingClientRect().height;

                if (elementWidth <= 0 || elementHeight <= 0) {
                    errorMessage += `<li>Størrelse for produktetikettelement "${elementName}" er feil</li>`;
                }

                if (fontSizeInput.length && !fontSizeInput.val()) {
                    errorMessage += `<li>Skriftstørrelse for produktetikettelement "${elementName}" er feil</li>`;
                }

                if (fontColorBtn.length && !fontColorBtn.css('background-color')) {
                    errorMessage += `<li>Skriftfarge for produktetikettelement "${elementName}" er feil</li>`;
                }

                if (textPositionSelect.length && !textPositionSelect.val()) {
                    errorMessage += `<li>Tekstposisjon for produktetikettelement "${elementName}" er feil</li>`;
                }

                if (imagePositionSelect.length && !imagePositionSelect.val()) {
                    errorMessage += `<li>Bildeposisjon for produktetikettelement "${elementName}" er feil</li>`;
                }
            });

            if (errorMessage) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', `<ul>${errorMessage}</ul>`, 'Lukk', 'error');
                return false;
            }

            return true;
        }

        function initColorPickers() {
            $('#product_label_element_settings_list .product_label_color_picker', document).each(function () {
                $(this).simpleColorPicker({
                    showEffect: 'fade',
                    hideEffect: 'slide',
                    onChangeColor: function (color) {
                        $(this).css("background", color);

                        const elementName = $(this).parents('.product_label_element_settings').attr('data-name');

                        $(`#product_label_canvas .draggable[data-name=${elementName}] .draggable-name`, document).css({
                            'color': `${color}`
                        });
                    }
                });
            });
        }

        function activateProductLabel(productLabelId) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel + '/' + productLabelId + ajaxPathProductLabelActivate,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke aktivere produktetikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hidePreloader();
            });
        }

        function deactivateProductLabel(productLabelId) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel + '/' + productLabelId + ajaxPathProductLabelDeactivate,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke deaktivere produktetikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hidePreloader();
            });
        }

        function createProductLabel(data) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel,
                data: data,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper', document).replaceWith(data.html);
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke opprette produktetikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hidePreloader();
            });
        }

        function updateProductLabel(productLabelId, data) {
            $.ajax({
                type: 'POST',
                url: ajaxPathProductLabel  + '/' + productLabelId,
                data: data,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_wrapper #product_label_list', document).html(data.html);
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke oppdatere produktetikett', 'Lukk', 'error');
            }).always(function () {
                ajaxLockActive = false;
                hidePreloader();
            });
            return false;
        }

        function getProductLabelForm(productLabelId) {
            $.ajax({
                type: 'GET',
                url: ajaxPathProductLabel + '/' + productLabelId,
                dataType: 'json'
            }).success(function (data) {
                $('#product_label_form_wrapper').replaceWith(data.html);
                calculateCanvas(data.params);
                initDraggable('.draggable');
                initColorPickers();
                initTooltip();
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke hente produktetikett', 'Lukk', 'error');
            }).always(function(){
                ajaxLockActive = false;
                hidePreloader();
            });
        }

        function refreshList() {
            const displayDeactivated = $('#product_label_list_wrapper input[name="display_deactivated"]', document).is(':checked')?'1':'0';

            $.ajax({
                type: 'GET',
                url: ajaxPathProductLabel,
                data: {
                    display_deactivated: displayDeactivated
                },
                dataType: 'json',
            }).success(function (data) {
                $('#product_label_list', document).html(data.html);
            }).error(function (data) {
                displayInfoMessageModal($('#product_label_wrapper', document), 'Det oppstod en feil!', 'Kunne ikke å oppdatere listen', 'Lukk', 'error');
            }).always(function () {
                hidePreloader();
                ajaxLockActive = false;
            });
        }

        function calculateCanvas(params) {
            const width = params.width;
            const height = params.height;
            const elements = params.elements;

            if (!width || !height || isNaN(width) || isNaN(height) || width <= 0 || height <= 0) {
                return;
            }

            if (!Object.keys(elements).length) {
                return;
            }

            scale = params.scale;
            const canvas = $('#product_label_form_wrapper #product_label_canvas', document);

            const aspectRatio = width / height;
            const canvasWidth = canvas[0].getBoundingClientRect().width;
            const canvasHeight = canvasWidth / aspectRatio;

            $('#product_label_form_wrapper #product_label_canvas .draggable', document).each(function (_, draggableElement) {
                const name = $(draggableElement).attr('data-name');
                if (!elements[name]) {
                    return;
                }

                // Set size and position of draggable element
                $(draggableElement).css({
                    'width': `${elements[name].width}px`,
                    'height': `${elements[name].height}px`,
                    'top': `${elements[name].y}px`,
                    'left': `${elements[name].x}px`
                });

                // Set text style of draggable element
                $(draggableElement).find('.draggable-name').css({
                    'font-size': `${elements[name].font_size}px`,
                    'color': `${elements[name].font_color}`
                });

                // Set text position of draggable element
                $(draggableElement).addClass(`${elements[name].text_position}`);

                $(draggableElement).attr('data-x', elements[name].x);
                $(draggableElement).attr('data-y', elements[name].y);

                // Set real size of draggable element
                $(draggableElement).find('.draggable-width').text(`${Number(elements[name].width * scale).toFixed(1)} mm`);
                $(draggableElement).find('.draggable-height').text(`${Number(elements[name].height * scale).toFixed(1)} mm`);
            });

            canvas.css({
                'height': `${Number(canvasHeight).toFixed(2)}px`
            });
        }

        $('#product_label_wrapper', document).on('input', 'input.input-integer', function(event) {
            const value = event.target.value;
            const sanitizedValue = value.replace(/[^0-9]/g, '');
            if (sanitizedValue !== value) {
                event.target.value = sanitizedValue;
            }
            return false;
        });


        $('#product_label_wrapper', document).on('input', '.product_label_element_font_size', function (event) {
            const elementName = $(this).parents('.product_label_element_settings').attr('data-name');
            $(`#product_label_canvas .draggable[data-name=${elementName}] .draggable-name`, document).css({
                'font-size': `${$(this).val()}px`
            });

            return false;
        });

        /**
         * @param {string|HTMLElement} target
         */
        function initDraggable(target) {
            interact(target).draggable({
                // inertia: true,
                modifiers: [
                    interact.modifiers.restrictRect({
                        restriction: 'parent',
                        // endOnly: true
                    })
                ],
                listeners: {
                    move(event) {
                        const $target = $(event.target);
                        let x = (parseFloat($target.attr('data-x')) || 0) + event.dx;
                        let y = (parseFloat($target.attr('data-y')) || 0) + event.dy;

                        $target.css({
                            'top': `${Number(y)}px`,
                            'left': `${Number(x)}px`
                        });

                        $target.attr('data-x', x);
                        $target.attr('data-y', y);
                    }
                }
            })
                .resizable({
                    edges: {left: true, right: true, bottom: true, top: true},
                    modifiers: [
                        interact.modifiers.restrictSize({
                            min: {width: draggableElementWidth, height: draggableElementHeight},
                        }),
                        interact.modifiers.restrictEdges({
                            outer: 'parent'
                        })
                    ],
                    // inertia: true
                })
                .on('resizemove', function (event) {
                    const $target = $(event.target);

                    let x = parseFloat($target.attr('data-x')) || 0;
                    let y = parseFloat($target.attr('data-y')) || 0;

                    // Update the element's size and position
                    $target.css({
                        width: `${Number(event.rect.width)}px`,
                        height: `${Number(event.rect.height)}px`,
                        top: `${Number(y + event.deltaRect.top)}px`,
                        left: `${Number(x + event.deltaRect.left)}px`
                    });

                    // Update real size of draggable element
                    $target.find('.draggable-width').text(`${Number(event.rect.width * scale).toFixed(1)} mm`);
                    $target.find('.draggable-height').text(`${Number(event.rect.height * scale).toFixed(1)} mm`);

                    $target.attr('data-x', x + event.deltaRect.left);
                    $target.attr('data-y', y + event.deltaRect.top);
                });
        }

        function isOverlapping(rect1, rect2) {
            return !(rect1.right < rect2.left ||
                rect1.left > rect2.right ||
                rect1.bottom < rect2.top ||
                rect1.top > rect2.bottom);
        }

        function checkOverlaps(elements) {
            for (let i = 0; i < elements.length; i++) {
                for (let j = i + 1; j < elements.length; j++) {
                    const block1Name = $(elements[i]).attr('data-name');
                    const block2Name = $(elements[j]).attr('data-name');
                    const rect1 = elements[i].getBoundingClientRect();
                    const rect2 = elements[j].getBoundingClientRect();

                    if (isOverlapping(rect1, rect2)) {
                        return false;
                    }
                }
            }

            return true;
        }

        function initTooltip() {
            $('[data-toggle="tooltip"]', document).tooltip({
                placement: 'bottom',
                html: true
            });
        }
    })();
});